module.exports = __webpack_public_path__ + "img/goldregen-2020-077.8c899b47.jpg";